import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'Inicio',
    component: () => import(/* webpackChunkName: "inicio" */ '../views/Bienvenida.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../general/Dashboard.vue'),
    meta:{ }
  },
  {
    path: '/acerca',
    name: 'Acerca',
    component: () => import(/* webpackChunkName: "acerca" */ '../views/About.vue'),
    meta:{ }
  },
  {
    path: '/versionamiento',
    name: 'Versionamiento',
    component: () => import(/* webpackChunkName: "versionamiento" */ '../views/Version.vue'),
    meta:{ }
  },  
  {
    path: '/entrar',
    name: 'Entrar',
    component: () => import(/* webpackChunkName: "entrar" */ '../views/Login.vue')
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component: () => import(/* webpackChunkName: "contacto" */ '../views/Contacto.vue')
  },
  {
    path: '/precios',
    name: 'Precios',
    component: () => import(/* webpackChunkName: "ventas" */ '../views/Pricing.vue')
  },
  {
    path: '/registro',
    name: 'Registro',
    component: () => import(/* webpackChunkName: "registro" */ '../views/Registro.vue')
  },
  {
    path: '/recuperar',
    name: 'Recuperar',
    component: () => import(/* webpackChunkName: "recovery" */ '../views/Recovery.vue')
  },
  {
    path: '/recuperarpass/:id',
    name: 'Recoverypass',
    component: () => import(/* webpackChunkName: "recoverypass" */ '../views/RecoveryPass.vue')
  },
  {
    path: '/iproyecto/:id',
    name: 'Iproyecto',
    component: () => import(/* webpackChunkName: "iproyecto" */ '../views/InvitadoProyecto.vue')
  },
  {
    path: '*',
    name: 'Error',
    component: () => import(/* webpackChunkName: "error" */ '../views/VistaError.vue')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
